/* "Complete your setup" rail.

   A static, swipeable carousel that advances itself one card at a time.
   It used to be a CSS marquee - a single track sliding continuously - which
   meant every card was permanently mid-motion and half-clipped by the edge
   fade. This scrolls to whole cards and rests between moves, so a card is
   readable and tappable the moment you look at it.

   Pauses on hover, on focus, and while the customer is scrolling it
   themselves. */
if (!customElements.get('cart-upsell-rail')) {
  customElements.define(
    'cart-upsell-rail',
    class CartUpsellRail extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.cart-drawer__track');
        if (!this.track || this.dataset.ready === 'true') return;
        requestAnimationFrame(() => this.setup());
      }

      disconnectedCallback() {
        this.stop();
      }

      setup() {
        if (!this.track || this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.cards = Array.from(this.track.querySelectorAll('.cart-upsell'));
        const scrollable = this.scrollWidth > this.clientWidth + 8;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.cards.length < 2 || !scrollable || reduce) return;

        this.index = 0;
        this.paused = false;

        var hold = () => { this.paused = true; };
        var release = () => { this.paused = false; };
        this.addEventListener('mouseenter', hold);
        this.addEventListener('mouseleave', release);
        this.addEventListener('focusin', hold);
        this.addEventListener('focusout', release);
        this.addEventListener('pointerdown', hold);
        this.addEventListener('touchstart', hold, { passive: true });
        this.addEventListener('touchend', () => setTimeout(release, 4000), { passive: true });

        // if they scroll it themselves, pick up from where they left it
        var settle;
        this.addEventListener(
          'scroll',
          () => {
            this.paused = true;
            clearTimeout(settle);
            settle = setTimeout(() => {
              this.index = this.nearestCard();
              this.paused = false;
            }, 2500);
          },
          { passive: true }
        );

        this.timer = setInterval(() => this.advance(), 3800);
      }

      nearestCard() {
        var left = this.scrollLeft;
        var best = 0;
        var bestGap = Infinity;
        this.cards.forEach((c, i) => {
          var gap = Math.abs(c.offsetLeft - left);
          if (gap < bestGap) { bestGap = gap; best = i; }
        });
        return best;
      }

      advance() {
        if (this.paused || !this.isConnected) return;
        // stop early if the tail of the last card is already showing
        var atEnd = this.scrollLeft + this.clientWidth >= this.scrollWidth - 4;
        this.index = atEnd ? 0 : this.index + 1;
        var card = this.cards[this.index];
        if (!card) { this.index = 0; card = this.cards[0]; }
        this.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
      }
    }
  );
}

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('cart-upsell-rail').forEach((el) => {
    el.stop && el.stop();
    delete el.dataset.ready;
    el.connectedCallback();
  });
});
